import api from './index'

class LogService {
    fetchLog(params) {
        return api.get('/log', {
            params
        })
    }
}

export default new LogService()